import {
  authHeader,
  authHeaderNoToken,
  handleResponse,
} from "../helper/auth-header";

export default class ContestService {
  ControllerName = "Contest";

  async CheckForContest(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CheckForContest`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetQuestions() {
    const requestOptions = {
      method: "GET",
      headers: authHeaderNoToken(),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetQuestions`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async InsertContestUserDetails(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/InsertContestUserDetails`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetContestBatchDetails(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetContestBatchDetails`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetWinnersList(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetWinnersList`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async SendContestWinnerEmail(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/SendContestWinnerEmail`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async AddContestBatchDetails(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/AddContestBatchDetails`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetContestUserReport(request) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(request),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetContestUserReport`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetContestToken(id) {
    debugger;
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GenrateNewToken?verificationId=${id}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
